import React from 'react';
import { Button, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Group gap="xs">
      <Globe size={16} />
      <Button
        variant={i18n.language === 'de' ? 'filled' : 'subtle'}
        size="xs"
        onClick={() => changeLanguage('de')}
      >
        DE
      </Button>
      <Button
        variant={i18n.language === 'en' ? 'filled' : 'subtle'}
        size="xs"
        onClick={() => changeLanguage('en')}
      >
        EN
      </Button>
    </Group>
  );
};

export default LanguageSwitcher;
